import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ClientSelect from '~components/ClientSelect';
import { saveClient } from '~redux/modules/clients.actions';
import { getActiveClients } from '~redux/selectors/clients';
import type { ClientDraft } from '~types/client';
import type { ThunkDispatch } from '~types/redux';

interface FallbackClientDropdownProps {
  value: number | null | undefined;
  onChange: (clientId: number | null) => void;
  className?: string;
}

export const IntegrationsSharedFallbackClientDropdown: React.FC<FallbackClientDropdownProps> = ({
  value,
  onChange,
  className,
}) => {
  const dispatch = useDispatch<ThunkDispatch>();
  const clients = useSelector(getActiveClients);

  const handleClientChange = (clientId: number) => {
    onChange(clientId);
  };

  const handleSaveClient = (clientDraft: ClientDraft) => {
    return dispatch(saveClient(clientDraft));
  };

  return (
    <ClientSelect
      value={value}
      onChange={handleClientChange}
      clients={clients}
      saveClient={handleSaveClient}
      canCreate={true}
      className={className}
    />
  );
};
